import React, { useState, useEffect } from 'react';
import api from '../../services/api';
import './Login.css';

const Login = () => {
  const [gatewayLoginUrl, setGatewayLoginUrl] = useState('');

  useEffect(() => {
    let cancelled = false;
    api.get('/Auth/GatewayLoginUrl')
      .then((res) => {
        if (!cancelled && res.data?.gatewayLoginUrl) {
          setGatewayLoginUrl(res.data.gatewayLoginUrl.trim());
        }
      })
      .catch(() => {});
    return () => { cancelled = true; };
  }, []);

  const handleLogin = () => {
    if (gatewayLoginUrl) {
      window.location.href = gatewayLoginUrl;
    }
  };

  return (
    <div className="login-container">
      <div className="login-gateway-block">
        <p className="login-gateway-message">To log in, You need to log in via the gateway.</p>
        <button
          type="button"
          className="login-gateway-btn"
          onClick={handleLogin}
          disabled={!gatewayLoginUrl}
        >
          Login
        </button>
      </div>
    </div>
  );
};

export default Login;
